// BUILD-046 session edit 4.3: whether the task table currently has its "Requested" column (Compact + "Show requester" on). The table header and every row read it
// here, from the same two stores the page reads, so a header and its rows can never disagree. The rule is requestedColumnShown (showRequesterStore.ts, tested).
import { useSyncExternalStore } from 'react';
import { density } from './densityStore';
import { requestedColumnShown, showRequester, showRequesterComfortable } from './showRequesterStore';

/** The Comfortable requester preference (Display menu): ON by default. */
export function useShowRequesterComfortable(): boolean {
  return useSyncExternalStore(showRequesterComfortable.subscribe, showRequesterComfortable.get);
}

/** The "Show requester" preference (for the Filter popover's Display section). */
export function useShowRequester(): boolean {
  return useSyncExternalStore(showRequester.subscribe, showRequester.get);
}

export function useRequestedColumn(variant: string): boolean {
  const currentDensity = useSyncExternalStore(density.subscribe, density.get);
  const show = useShowRequester();
  return requestedColumnShown(currentDensity, show, variant);
}
